package com.wintermar.inspection.feature.presentation.auth.login

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.core.ui.component.snackbar.util.SnackBarController
import com.wintermar.inspection.core.ui.component.snackbar.util.SnackBarVariant
import com.wintermar.inspection.feature.domain.usecase.auth.LoginUseCase
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach

class LoginViewModel(
    private val loginUseCase: LoginUseCase,
) : ViewModel() {
    val state = LoginState(
        scope = viewModelScope,
        onSubmit = { email, password ->
            onLogin(email, password)
        }
    )

    private fun onLogin(email: String, password: String) {
        loginUseCase(email, password)
            .onEach { result ->
                when (result) {
                    is FlowResult.Loading -> {
                        state.isLoading = result.showLoading
                    }

                    is FlowResult.Success -> {
                        if (result.data?.failedAttemptMessage?.isNotBlank() == true) {
                            showErrorSnackBar(result.data.failedAttemptMessage)
                        } else {
                            state.onLoginSuccess?.invoke()
                        }
                    }

                    is FlowResult.Error -> showErrorSnackBar(result.error?.message ?: "Login failed. Please try again.")
                }
            }
            .launchIn(viewModelScope)
    }

    private suspend fun showErrorSnackBar(message: String) {
        SnackBarController.show(
            message = message,
            variant = SnackBarVariant.ERROR
        )
    }
}
